import CivilEngineerRealEstateSvg from "./assets/civil-engineer-real-estate.svg"
import CivilServantSvg from "./assets/civil-servant.svg"
import ConsultantSvg from "./assets/consultant.svg"
import CorporateSvg from "./assets/corporate.svg"
import CreatorSvg from "./assets/creator.svg"
import DesignerSvg from "./assets/designer.svg"
import DirectorSvg from "./assets/director.svg"
import EngineerSvg from "./assets/engineer.svg"
import FinanceSvg from "./assets/finance.svg"
import ManagementSvg from "./assets/management.svg"
import MarketerSvg from "./assets/marketer.svg"
import PlannerSvg from "./assets/planner.svg"
import SalesSvg from "./assets/sales.svg"
import ScientistSvg from "./assets/scientist.svg"
import WriterSvg from "./assets/writer.svg"

const _CATEGORY_IMAGE_MAP = {
  management: <ManagementSvg />,
  planner: <PlannerSvg />,
  sales: <SalesSvg />,
  marketer: <MarketerSvg />,
  consultant: <ConsultantSvg />,
  finance: <FinanceSvg />,
  engineer: <EngineerSvg />,
  scientist: <ScientistSvg />,
  designer: <DesignerSvg />,
  creator: <CreatorSvg />,
  writer: <WriterSvg />,
  director: <DirectorSvg />,
  corporate: <CorporateSvg />,
  "civil-engineer-real-estate": <CivilEngineerRealEstateSvg />,
  "civil-servant": <CivilServantSvg />,
} as const

export type CategoryType = keyof typeof _CATEGORY_IMAGE_MAP

export const CATEGORY_IMAGE_MAP_STRICT: Record<CategoryType, JSX.Element> = _CATEGORY_IMAGE_MAP
export const CATEGORY_IMAGE_MAP: Record<string, JSX.Element | undefined> = _CATEGORY_IMAGE_MAP
